import { useNavigate } from "react-router-dom";
import { Cotizador } from "../../components/kit/Cotizador";

export default function PortalCotizar() {
  const nav = useNavigate();
  return <div data-testid="portal-cotizar"><Cotizador portal onClose={() => nav("/portal")} onConvert={(q) => nav("/portal/referir", { state: { cotizacion: q } })} /></div>;
}
